'use strict';

/**
 * Function to get promotion price by adding tier based discount on bundle total
 * @param {number} totalSalePrice Total sale price of Bundle
 * @returns {Object} returnData Object containing discount percentage and amount
 */
function getOverrideDiscountData(totalSalePrice) {
    var promotionPercent = $('.js-bundle-promo-override-percentage').val();
    var isPromotionActive = $('.js-is-bundle-overridepromo-active').val();
    var returnData = {
        discountedTotal: 0,
        discountPercentage: 0,
        discountAmt: 0
    };
    var maxThresholdObj = JSON.parse($('.js-promooverride-maxthresholdobj').val());
    if (maxThresholdObj) {
        var orderThreshold = 9999;
        var discountPercentage;
        var dicountedTotal;
        var discountAmt;
        if (maxThresholdObj.threshold) {
            orderThreshold = maxThresholdObj.threshold;
        }
        if (totalSalePrice > orderThreshold) {
            dicountedTotal = totalSalePrice - maxThresholdObj.amountOff;
            discountAmt = maxThresholdObj.amountOff;
            discountPercentage = 0;
            returnData.discountPercentage = discountPercentage;
            returnData.discountedTotal = dicountedTotal;
            returnData.discountAmt = discountAmt;
        } else {
            if (isPromotionActive === 'true' && promotionPercent > 0) { // eslint-disable-line no-lonely-if
                discountPercentage = Number(promotionPercent);
                discountAmt = totalSalePrice * (discountPercentage / 100);
                dicountedTotal = totalSalePrice - discountAmt;
                returnData.discountPercentage = discountPercentage;
                returnData.discountedTotal = dicountedTotal;
                returnData.discountAmt = discountAmt;
            }
        }
    }
    return returnData;
}

/**
 * Function to get promotion price by adding tier based discount on bundle total
 * @param {number} totalSalePrice Total sale price of Bundle
 * @returns {Object} returnData Object containing discount percentage and amount
 */
function getDiscountData(totalSalePrice) {
    var promotionDataObj = JSON.parse($('.js-bundle-promo-data').val());
    var isPromotionActive = $('.js-is-bundle-promo-active').val();
    var returnData = {
        discountedTotal: 0,
        discountPercentage: 0,
        discountAmt: 0
    };
    if (isPromotionActive === 'true' && promotionDataObj) {
        var thresholdValArr = Object.keys(promotionDataObj);
        thresholdValArr.forEach(function (threshold) {
            var orderThreshold;
            var discountPercentage;
            var dicountedTotal;
            var discountAmt;
            if (threshold === 'max') {
                orderThreshold = promotionDataObj[threshold].threshold;
                if (totalSalePrice > orderThreshold) {
                    dicountedTotal = totalSalePrice - promotionDataObj[threshold].amountOff;
                    discountAmt = promotionDataObj[threshold].amountOff;
                    discountPercentage = 0;
                    returnData.discountPercentage = discountPercentage;
                    returnData.discountedTotal = dicountedTotal;
                    returnData.discountAmt = discountAmt;
                }
            } else {
                orderThreshold = Number(threshold);
                if (!isNaN(orderThreshold)) {
                    if (totalSalePrice > orderThreshold) {
                        discountPercentage = promotionDataObj[threshold];
                        discountAmt = totalSalePrice * (discountPercentage / 100);
                        dicountedTotal = totalSalePrice - discountAmt;
                        returnData.discountPercentage = discountPercentage;
                        returnData.discountedTotal = dicountedTotal;
                        returnData.discountAmt = discountAmt;
                    }
                }
            }
        });
    }
    return returnData;
}

/**
 * Function to get selected Items array for add to cart event
 * @returns {Array} pidArr array of product:qty strings
 */
function getSelectedItemsArrCart() {
    var pidArr = [];
    $('.js-default-item').each(function () {
        pidArr.push($(this).data('pid') + ':' + 1);
    });

    if ($('.js-selected-qty').length > 0) {
        $('.js-selected-qty').each(function () {
            var selectedQty = Number($(this).val());
            if (selectedQty > 0) {
                pidArr.push($(this).data('pid') + ':' + selectedQty);
            }
        });
    }

    return pidArr;
}

/**
 * Function to get selected Items array
 * @returns {Array} pidArr array of product:qty strings
 */
function getSelectedItemsArr() {
    var pidArr = [];
    if ($('.js-selected-qty').length > 0) {
        $('.js-selected-qty').each(function () {
            var selectedQty = Number($(this).val());
            if (selectedQty > 0) {
                pidArr.push($(this).data('pid') + ':' + selectedQty);
            }
        });
        if (pidArr.length) {
            $('.js-default-item').each(function () {
                pidArr.push($(this).data('pid') + ':' + 1);
            });
        }
    }
    return pidArr;
}

/**
 * Function to determine list and sale price of an item and return them with qty multiplied
 * @param {Object} priceObj Item price object
 * @param {number} selectedQty Item qty
 * @returns {Object} itemPrices Object with item prices
 */
function getListAndSalePrice(priceObj, selectedQty) {
    var itemPrices = {
        itemSalePrice: 0,
        itemListPrice: 0
    };
    if (priceObj.promotionPrice) {
        if (priceObj.salesPrice && priceObj.promotionPrice < priceObj.salesPrice) {
            itemPrices.itemSalePrice = priceObj.promotionPrice * selectedQty;
        }
    } else if (priceObj.salesPrice) {
        itemPrices.itemSalePrice = priceObj.salesPrice * selectedQty;
    }
    if (priceObj.listPrice) {
        itemPrices.itemListPrice = priceObj.listPrice * selectedQty;
    }
    return itemPrices;
}

/**
 * Function to update totals after item selection
 */
function updateTotals() {
    var totalSalePrice = 0;
    var totalListPrice = 0;
    var itemCount = 0;
    var hasDiscountOverrideItem = false;
    var dicountOverridePID = $('.js-bundle-promo-override-pid').val();
    var dicountOverridePIDArr = [];
    if (dicountOverridePID.length > 0) {
        dicountOverridePIDArr = dicountOverridePID.split(',');
    }
    if ($('.js-selected-qty').length > 0) {
        var priceObj;
        var itemPrices = {
            itemSalePrice: 0,
            itemListPrice: 0
        };
        $('.js-byob-add-all').prop('disabled', false);
        $('.js-selected-qty').each(function () {
            var selectedQty = Number($(this).val());
            if (selectedQty > 0) {
                if (dicountOverridePIDArr.indexOf($(this).data('pid')) >= 0) {
                    hasDiscountOverrideItem = true;
                }
                priceObj = $(this).data('priceobj');
                itemPrices = {
                    itemSalePrice: 0,
                    itemListPrice: 0
                };
                itemPrices = getListAndSalePrice(priceObj, selectedQty);
                $(this).closest('.price-qty').find('.js-selected-price-tag').text($('.js-site-currency').val() + itemPrices.itemSalePrice.toFixed(2));
                if (itemPrices.itemSalePrice < itemPrices.itemListPrice) {
                    $(this).closest('.price-qty').find('.js-selected-listprice-tag').text($('.js-site-currency').val() + itemPrices.itemListPrice.toFixed(2));
                }
                totalSalePrice += itemPrices.itemSalePrice;
                totalListPrice += itemPrices.itemListPrice;
                itemCount++;
            } else {
                $(this).closest('.price-qty').find('.js-selected-price-tag').text($('.js-site-currency').val() + 0);
                $(this).closest('.price-qty').find('.js-selected-listprice-tag').text('');
            }
        });
    }
    $('.js-defaultitem-price').each(function () {
        var defaultPriceObj = $(this).data('priceobj');
        var defaultItemPrices = {
            itemSalePrice: 0,
            itemListPrice: 0
        };
        defaultItemPrices = getListAndSalePrice(defaultPriceObj, 1);
        totalSalePrice += defaultItemPrices.itemSalePrice;
        totalListPrice += defaultItemPrices.itemListPrice;
        itemCount++;
    });
    var discountData = {};
    var isOverridePromotionActive = $('.js-is-bundle-overridepromo-active').val();
    if (isOverridePromotionActive === 'true' && hasDiscountOverrideItem === true) {
        discountData = getOverrideDiscountData(totalSalePrice);
    } else {
        discountData = getDiscountData(totalSalePrice);
    }

    if (totalListPrice > totalSalePrice) {
        $('.js-total-list-price').each(function () {
            $(this).text($('.js-site-currency').val() + totalListPrice.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));
            $(this).removeClass('d-none');
        });
    } else {
        $('.js-total-list-price').each(function () {
            $(this).addClass('d-none');
        });
    }
    if (discountData.discountedTotal !== 0 && discountData.discountedTotal < totalSalePrice) {
        $('.js-total-sale-price').each(function () {
            $(this).text($('.js-site-currency').val() + discountData.discountedTotal.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));
        });
        var discountMsg = '-' + $('.js-site-currency').val() + discountData.discountAmt.toFixed(2);
        if (discountData.discountPercentage > 0) {
            discountMsg += ' (' + discountData.discountPercentage.toFixed() + '% off)';
        }
        $('.js-bundle-discount-amt').text(discountMsg);
        $('.byb-discount').removeClass('d-none');
        $('.js-total-list-price').each(function () {
            $(this).text($('.js-site-currency').val() + totalListPrice.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));
            $(this).removeClass('d-none');
        });
    } else {
        $('.byb-discount').addClass('d-none');
        $('.js-total-sale-price').each(function () {
            $(this).text($('.js-site-currency').val() + totalSalePrice.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }));
        });
    }

    $('.js-hybrid-itemcount').text('(' + itemCount + ' items)');

    // Update affirm with new totals
    if ($('.js-byob-affirmpromo-min').length) {
        var affirmMinTotal = Number($('.js-byob-affirmpromo-min').val());
        if (totalSalePrice < affirmMinTotal) {
            $('.js-affirm-cart-total').addClass('d-none');
        } else {
            if ($('.js-affirm-cart-total').length > 0) {
                $('.js-affirm-cart-total').removeClass('d-none');
                $('.js-affirm-cart-total').attr('data-amount', totalSalePrice * 100);
            }
            if (typeof affirm !== 'undefined') { // eslint-disable-line
                affirm.ui.ready(function() { // eslint-disable-line
                    affirm.ui.refresh(); // eslint-disable-line
                });
            }
        }
    }

    // Update sticky nav
    $('.product-nav.BYB').find('.js-view-bundle-button').hide();
    $('.product-nav.BYB').find('.js-view-bundle-button').fadeOut();
    $('.product-nav.BYB').addClass('active');
    $('.product-nav.BYB').find('.js-bundle-updated').show();

    setTimeout(() => {
        $('.product-nav.BYB').removeClass('active');
        $('.product-nav.BYB').find('.js-bundle-updated').hide();
        $('.product-nav.BYB').find('.js-view-bundle-button').fadeIn(500);
    }, 1000);
}

/**
 * Initialize selected section input events
 */
function initializeSelectedQtyControls() {
    // Event Handlers for Quantity Controls in selected items section
    $('body').on('click', '.js-selected-liq-minus', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var selectedInput = $(this).parent().find('input[type=number]');
        var prodid = $(selectedInput).data('pid');
        if (Number($(selectedInput).val()) !== 0) {
            this.parentNode.querySelector('input[type=number]').stepDown();
            $(selectedInput).trigger('change');
            var quantity = Number($(selectedInput).val());
            if (quantity === 0) {
                $('.js-selected-products').find('.selected-' + prodid).remove();
            }
            $('.js-segment-qty[data-pid=' + prodid + ']').val(quantity);
            $('.js-segment-qty[data-pid=' + prodid + ']').trigger('change');
            updateTotals();
        }
    });

    $('body').on('click', '.js-selected-liq-plus', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        var selectedInput = $(this).parent().find('input[type=number]');
        var ats = $(selectedInput).data('ats');
        ats = parseInt(ats, 10);
        var maxValue = parseInt($(selectedInput).prop('max'), 10);
        if (Number($(selectedInput).val()) < ats && Number($(selectedInput).val()) < maxValue) {
            this.parentNode.querySelector('input[type=number]').stepUp();
            $(selectedInput).trigger('change');
            var quantity = Number($(selectedInput).val());
            var prodid = $(selectedInput).data('pid');
            $('.js-segment-qty[data-pid=' + prodid + ']').val(quantity);
            $('.js-segment-qty[data-pid=' + prodid + ']').trigger('change');
            updateTotals();
        } else {
            $(this).prop('disabled', true);
            $('<div style="display:none" class="js-selecteditem-qty-exceed-error-msg justify-content-end backorder">' + $('.js-qty-exceed-error-msg').eq(0).text() + '</div>').insertAfter($(this).closest('.js-selected-item-parent'));
            $('.js-selecteditem-qty-exceed-error-msg').slideDown();
            $(this).closest('.js-item-price-col').find('.js-qty-exceed-error-msg').slideDown();
            setTimeout(() => {
                $('.js-selecteditem-qty-exceed-error-msg').slideUp();
                $(this).closest('.js-item-price-col').find('.js-qty-exceed-error-msg').slideUp();
            }, 3000);
            setTimeout(() => {
                $('.js-selecteditem-qty-exceed-error-msg').remove();
                $(this).prop('disabled', false);
            }, 4500);
        }
    });
}

var exports = {
    initialize: function () {
        // enable add to cart button if dfault items exist
        if ($('.js-defaultitem-price').length > 0) {
            $('.js-byob-add-all').prop('disabled', false);
        }
        // Trigger Modals on hover
        $('.byb-info-icon').on('mouseover', function () {
            if ($(this).data('toggle') === 'modal') {
                $($(this).data('target')).modal('show');
            }
        });
        var urlParams = new URLSearchParams(window.location.search);
        var pidstr = urlParams.get('pidstr');
        var $byobPids = [];
        if (pidstr) {
            var pairs = pidstr.split(',');
            for (var i = 0; i < pairs.length; i++) {
                var pair = pairs[i].split(':');
                $byobPids.push(pair[0]);
            }
            $byobPids.reverse();
        } else {
            $byobPids = JSON.parse($('.byob-segments').attr('data-hybridbundledata')).reverse();
        }

        // Update pre-selection on edit and email landing
        $byobPids.forEach(function (productID) {
            $('.js-segment-qty').each(function () {
                if ($(this).val() > 0) {
                    var prodID = $(this).data('pid');
                    if (productID === prodID) {
                        var selectedQty = Number($(this).val());
                        if ($('.js-selected-products').find('.selected-' + prodID).length > 0) {
                            $('.selected-' + prodID).find('.js-selected-qty').val(selectedQty);
                            $('.selected-' + prodID).find('.js-selected-qty').trigger('change');
                        } else {
                            var prodName = $(this).data('pname');
                            var priceObjStr = $(this).data('priceobj');
                            var ats = $(this).data('ats');
                            priceObjStr = JSON.stringify(priceObjStr);
                            var selectedItemString = `<div class="js-selected-item-parent selected-${prodID}">
                                                        <p class="js-selected-item-name">${prodName}</p>
                                                        <div class="price-qty">
                                                            <div class="line-item-quantity">
                                                                <button class="js-selected-liq-minus minus legal-text">-</button>
                                                                <input readonly="readonly" data-ats="${ats}" data-priceobj=${priceObjStr} class="quantity js-selected-qty legal-bold-text" min="0" max="10" value="${selectedQty}" type="number" name="quantity" data-pid="${prodID}"/>
                                                                <button class="js-selected-liq-plus plus legal-text">+</button>
                                                            </div>
                                                            <div class="byob-summary-prices">
                                                                <p class="js-selected-listprice-tag byb-selected-price-tag byb-ptile-list-strike"></p>
                                                                <p class="js-selected-price-tag byb-selected-price-tag"></p>
                                                            </div>
                                                        </div>
                                                      </div>`;
                            $(selectedItemString).insertAfter('.js-a2c-default');
                        }
                        initializeSelectedQtyControls();
                        updateTotals();
                    }
                }
            });
        });
        // Event Handlers for Quantity Controls
        $('body').on('click', '.js-liq-minus', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            var productInputField = $(this).parent().find('input[type=number]');
            var minusValue = Number($(productInputField).val());
            var prodID = $(productInputField).data('pid');
            if (minusValue === 1) {
                $('.js-selected-products').find('.selected-' + prodID).remove();
                this.parentNode.querySelector('input[type=number]').stepDown();
            }
            if (minusValue > 1) {
                this.parentNode.querySelector('input[type=number]').stepDown();
                $(this).parent().find('input[type=number]').trigger('change');
                var selectedQty = Number($(productInputField).val());
                if ($('.js-selected-products').find('.selected-' + prodID).length > 0) {
                    $('.selected-' + prodID).find('.js-selected-qty').val(selectedQty);
                    $('.selected-' + prodID).find('.js-selected-qty').trigger('change');
                }
            }
            updateTotals();
        });

        $('body').on('click', '.js-liq-plus', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            var productInputField = $(this).parent().find('input[type=number]');
            var ats2 = $(productInputField).data('ats');
            ats2 = parseInt(ats2, 10);
            var maxValue = parseInt($(productInputField).prop('max'), 10);
            var plusValue = Number($(productInputField).val());
            if (plusValue < ats2 && plusValue < maxValue) {
                this.parentNode.querySelector('input[type=number]').stepUp();
                $(this).parent().find('input[type=number]').trigger('change');
                if ($(productInputField).val() > 0) {
                    var prodID = $(productInputField).data('pid');
                    var selectedQty = Number($(productInputField).val());
                    if ($('.js-selected-products').find('.selected-' + prodID).length > 0) {
                        $('.selected-' + prodID).find('.js-selected-qty').val(selectedQty);
                        $('.selected-' + prodID).find('.js-selected-qty').trigger('change');
                    } else {
                        var prodName = $(productInputField).data('pname');
                        var priceObjStr = $(productInputField).data('priceobj');
                        priceObjStr = JSON.stringify(priceObjStr);
                        var selectedItemString = `<div class="js-selected-item-parent selected-${prodID} byb-selected-prod">
                                                    <p class="js-selected-item-name">${prodName}</p>
                                                    <div class="price-qty">
                                                        <div class="line-item-quantity">
                                                            <button class="js-selected-liq-minus minus legal-text">-</button>
                                                            <input readonly="readonly" data-ats="${ats2}" data-priceobj=${priceObjStr} class="quantity js-selected-qty legal-bold-text" min="0" max="10" value="${selectedQty}" type="number" name="quantity" data-pid="${prodID}"/>
                                                            <button class="js-selected-liq-plus plus legal-text">+</button>
                                                        </div>
                                                        <div class="byob-summary-prices">
                                                            <p class="js-selected-listprice-tag byb-selected-price-tag byb-ptile-list-strike"></p>
                                                            <p class="js-selected-price-tag byb-selected-price-tag"></p>
                                                        </div>
                                                    </div>
                                                </div>`;
                        $(selectedItemString).insertBefore('.byob-added-seperator');
                    }
                    initializeSelectedQtyControls();
                    updateTotals();
                }
            } else {
                $(this).closest('.js-item-price-col').find('.js-qty-exceed-error-msg').slideDown();
                setTimeout(() => {
                    $(this).closest('.js-item-price-col').find('.js-qty-exceed-error-msg').slideUp();
                }, 3000);
            }
        });

        $('body').on('click', '.js-byob-add-all', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            $(this).prop('disabled', true);
            var pidArr = getSelectedItemsArrCart();
            if (pidArr.length) {
                var pidStr = pidArr.join(',');
                var addToCartUrl = $(this).data('addurl');
                var add2CUrl = addToCartUrl + pidStr;
                if ($('.js-byob-src-code').val().length) {
                    add2CUrl += '&src=' + $('.js-byob-src-code').val();
                }
                $('body').spinner().start();
                $.ajax({
                    url: add2CUrl,
                    type: 'get'
                }).done(function (data) {
                    $('body').spinner().stop();
                    if (data.error === true) {
                        // Display a popup with error msgs and show go to cart button
                    }
                    if (data.errorMsgs && data.errorMsgs.length) {
                        data.errorMsgs.forEach(function (error) {
                            $('.js-a2c-product-errors').html('<li>' + error + '</li>');
                        });
                        $('#byobA2Cerrormodal').modal('show');
                        $('.js-byob-add-all').prop('disabled', false);
                    } else if (!!data.atsBundleRemoved && data.atsBundleRemoved === true) {
                        $('.js-ats-bundle-removed').removeClass('d-none');
                        $('.js-ats-bundle-removed').addClass('d-block');
                        $('#atsRemovedModal').modal('show');
                    } else {
                        window.location.href = $('.js-cart-page-url').val();
                    }
                });
            } else {
                $(this).prop('disabled', false);
                // Show no-items selected error message
            }
        });

        $('body').on('click', '.js-a2c-error-goto-cart', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            $('body').spinner().start();
            window.location.href = $('.js-cart-page-url').val();
        });

        $(document).on('click', '.js-Back-to-Top', function () {
            $('html,body').animate({
                scrollTop: 0
            }, 1000);
        });

        $(document).on('click', '.js-view-bundle-button', function () {
            $('html,body').animate({
                scrollTop: $('.BYB-order-summary').offset().top - 150
            }, 1000);
        });
    },
    initializeEmailModalEvents: function () {
        // Clear old values from Email modal on show
        $('#emailMyBundleModal').on('show.bs.modal', function () {
            $('input.js-byob-email').val('');
            $('button.js-byob-email-submit').prop('disabled', true);
            $('.js-email-invalid-msg').addClass('d-none');
            $('.js-email-modal-content').removeClass('d-none');
            $('.js-email-response-content').addClass('d-none');
            $('.js-no-items-modal-msg').addClass('d-none');
            $('input.js-byob-email').removeClass('emailError');
        });

        $('body').on('blur', 'input.js-byob-email', function () {
            var useremail = $(this).val();
            if (useremail.trim().length) {
                var pattern = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/gi;
                if (pattern.test(useremail)) {
                    $('button.js-byob-email-submit').prop('disabled', false);
                    $('.js-email-invalid-msg').addClass('d-none');
                } else {
                    $('button.js-byob-email-submit').prop('disabled', true);
                    $('.js-email-invalid-msg').removeClass('d-none');
                    $('input.js-byob-email').addClass('emailError');
                }
            } else {
                $('button.js-byob-email-submit').prop('disabled', true);
                $('.js-email-invalid-msg').addClass('d-none');
            }
        });

        $('body').on('click', '.js-byob-email-submit', function (e) {
            e.stopImmediatePropagation();
            e.preventDefault();
            var useremail = $('input.js-byob-email').val();
            if (useremail.trim().length) {
                if ($('.js-selected-qty').length > 0) {
                    var pidArr = getSelectedItemsArr();
                    if (pidArr.length) {
                        $('.js-no-items-modal-msg').addClass('d-none');
                        var pidStr = pidArr.join(',');
                        var emailUrl = $('.js-email-trigger-url').val();
                        var defaultItemPid = $('.js-default-item').eq(0).data('pid');
                        var mainBuilderPid = $('.product-detail.product-wrapper.buildYourOwnBundle').data('pid');
                        $('.modal-body').spinner().start();
                        $.ajax({
                            url: emailUrl,
                            type: 'post',
                            dataType: 'json',
                            data: {
                                pidStr: pidStr,
                                useremail: useremail,
                                defaultItemPid: defaultItemPid,
                                mainBuilderPid: mainBuilderPid
                            }
                        }).done(function (data) {
                            $('.modal-body').spinner().stop();
                            $('.js-email-modal-content').addClass('d-none');
                            $('.js-email-response-content').removeClass('d-none');
                            if (data.error) {
                                $('.js-modal-response-msg').text(data.errorMsg);
                            } else {
                                $('.js-byobemail-modal-title').text('Your bundle is in your inbox.');
                                $('.js-modal-response-msg').html(data.successMsg);
                                $('.emailMyBundleModalBody').addClass('emailSuccModal');
                            }
                        });
                    } else {
                        $('.js-no-items-modal-msg').removeClass('d-none');
                        $('input.js-byob-email').addClass('emailError');
                    }
                } else {
                    $('.js-no-items-modal-msg').removeClass('d-none');
                    $('input.js-byob-email').addClass('emailError');
                }
            } else {
                $('button.js-byob-email-submit').prop('disabled', true);
                $('.js-email-invalid-msg').removeClass('d-none');
                $('input.js-byob-email').addClass('emailError');
            }
        });
    }
};

module.exports = exports;
